import {ListActionButton} from "components/common";
import {ColumnsEdit} from "types/models/column-table-edit";
import React from "react";

const supplyCatalogColumns: ColumnsEdit = [
  {
    title: "Mã loại vật tư",
    dataIndex: "id",
    key: "id",
    show: true,
    align: "center",
    width: 120,
  },
  {
    title: "Tên loại vật tư",
    dataIndex: "name",
    key: "name",
    show: true,
    align: "left",
  },
  {
    title: "Mô tả",
    dataIndex: "description",
    show: true,
    align: "left",
  },
  {
    title: "Ghi chú",
    dataIndex: "note",
    show: true,
    align: "left",
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    render: index => (
      <ListActionButton key={index} deleteFunction={null} editFunction={null} />
    ),
    width: 80,
  },
];

export {supplyCatalogColumns};
